import { render, staticRenderFns } from "./ComplieRightMenuAniMal.vue?vue&type=template&id=8061fe3a&scoped=true"
import script from "./ComplieRightMenuAniMal.vue?vue&type=script&lang=js"
export * from "./ComplieRightMenuAniMal.vue?vue&type=script&lang=js"
import style0 from "./ComplieRightMenuAniMal.vue?vue&type=style&index=0&id=8061fe3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8061fe3a",
  null
  
)

export default component.exports